export default __webpack_public_path__ + "static/media/stspeterandpaul.a5e1c5ae.jpg";